import { render, staticRenderFns } from "./ComeVisaMessage.vue?vue&type=template&id=3cdc3d26"
import script from "./ComeVisaMessage.vue?vue&type=script&lang=js"
export * from "./ComeVisaMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports